<template>
    <div class="container">
        <div class="field p-l-20">
            <Checkbox type="radio" name="schedule_type" v-model="model.schedule_type" data-value="unknown" label="Aún no lo tengo claro"></Checkbox>
        </div>
        <div class="field p-l-20">
            <Checkbox type="radio" name="schedule_type" v-model="model.schedule_type" data-value="regular" label="Mismo horario cada día"></Checkbox>
        </div>
        <div v-if="model.schedule_type === 'regular'">
            <p class="candidtext is-size-6 m-b-10">Utilice el botón <span class="minirounded bluetext prettypink has-text-centered" style="margin-left: 0;">&#43;</span> para añadir un nuevo turno</p>
            <table class="table is-bordered is-narrow is-hoverable selectors" id="scroll-regular-schedule">
                <thead>
                    <tr>
                        <th>Desde</th>
                        <th>Hasta</th>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(slot, slot_index) of model.schedule_single">
                        <td>
                            <div class="select">
                                <select v-model="slot.start">
                                    <option :value="null">--:--</option>
                                    <option v-for="hour of getStartSlotsFromSingle(slot)" :value="hour.value">
                                        {{ hour.display }}
                                    </option>
                                </select>
                            </div>
                        </td>
                        <td>
                            <div class="select">
                                <select v-model="slot.end">
                                    <option :value="null">--:--</option>
                                    <template v-for="hour of getEndSlotsFromSingle(slot)">
                                        <template v-if="Array.isArray(hour)">
                                            <optgroup label="Día siguiente">
                                                <option v-for="h of hour" :value="{ is_next_day: true, hour: h.value }">{{ h.display }}</option>
                                            </optgroup>
                                        </template>
                                        <template v-else>
                                            <option :value="{ is_next_day: false, hour: hour.value }">{{ hour.display }}</option>
                                        </template>
                                    </template>
                                </select>
                            </div>
                        </td>
                        <td>
                            <span v-if="model.schedule_single.length > 1"
                                  class="minirounded bluetext prettypink has-text-centered"
                                  @click.prevent="removeSlotOnlyDay(slot)">&#45;</span>
                            <template v-if="slot_index === model.schedule_single.length - 1 && model.schedule_single.length <= 1">
                                <span class="minirounded bluetext prettypink has-text-centered"
                                      @click.prevent="addSlotOnlyDay">&#43;</span>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="field p-l-20">
            <Checkbox type="radio" name="schedule_type" v-model="model.schedule_type" data-value="always" label="24 horas al día (interna)"></Checkbox>
        </div>
        <div class="field p-l-20">
            <Checkbox type="radio" name="schedule_type" v-model="model.schedule_type" data-value="customized" label="Horario distinto cada día"></Checkbox>
        </div>
        <div v-if="model.schedule_type === 'customized'">
            <p class="candidtext is-size-6 m-b-10">Utilice el botón <span class="minirounded bluetext prettypink has-text-centered" style="margin-left: 0;">&#43;</span> para añadir un nuevo turno</p>
            <table class="table selectors" id="scroll-customized-schedule">
                <thead>
                    <tr>
                        <th>Día</th>
                        <th>Turnos</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="day of selectedDays">
                        <td class="bluetext">{{ day.short }}</td>
                        <td>
                            <table class="table is-bordered is-narrow is-hoverable selectors">
                                <thead>
                                    <tr>
                                        <td>Desde</td>
                                        <td>Hasta</td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(slot, slot_index) of model.schedule_multiple[model.days.indexOf(day)]">
                                        <td>
                                            <div class="select">
                                                <select v-model="slot.start">
                                                    <option :value="null">--:--</option>
                                                    <option v-for="hour of getStartSlotsFromMultiple(day, slot)" :value="hour.value">
                                                        {{ hour.display }}
                                                    </option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="select">
                                                <select v-model="slot.end">
                                                    <option :value="null">--:--</option>
                                                    <template v-for="hour of getEndSlotsFromMultiple(day, slot)">
                                                        <template v-if="Array.isArray(hour)">
                                                            <optgroup label="Día siguiente">
                                                                <option v-for="h of hour" :value="{ is_next_day: true, hour: h.value }">{{ h.display }}</option>
                                                            </optgroup>
                                                        </template>
                                                        <template v-else>
                                                            <option :value="{ is_next_day: false, hour: hour.value }">{{ hour.display }}</option>
                                                        </template>
                                                    </template>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <span v-if="model.schedule_multiple[model.days.indexOf(day)].length > 1"
                                                  class="minirounded bluetext prettypink has-text-centered"
                                                  @click.prevent="removeSlotMultipleDay(day, slot)">&#45;</span>
                                            <template v-if="slot_index === model.schedule_multiple[model.days.indexOf(day)].length - 1 && model.schedule_multiple[model.days.indexOf(day)].length <= 1">
                                                <span class="minirounded bluetext prettypink has-text-centered"
                                                      @click.prevent="addSlotMultipleDay(day)">&#43;</span>
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import stepMixin from '../mixins/step';
import Checkbox from './Checkbox';

export default {
  name: 'funnel-paso-5',
  components: {
    Checkbox
  },
  mixins: [
    stepMixin
  ],
  methods: {
    updateScroll: function (id) {
      const target = document.getElementById(id);

      window.scrollTo({
        top: target.getBoundingClientRect().top + target.offsetHeight
      });
    },
    getStartSlotsFromSingle: function (slot) {
      var day_slots  = this.model.schedule_single;
      var slot_index = day_slots.indexOf(slot);

      var previous_slot = slot_index > 0 ? day_slots[slot_index - 1] : null;

      if (previous_slot) {
        return Array(24 - previous_slot.end.hour - 1).fill(null).map(function (el, i) {
          var offset_i = i + previous_slot.end.hour + 1;

          if (offset_i > 23) {
            offset_i -= 24;

            return Array(previous_slot.end.hour + 1).fill(null).map(function (el, sub_i) {
              var sub_offset_i = offset_i + sub_i;

              return {
                value: sub_offset_i,
                display: (sub_offset_i > 9 ? sub_offset_i : ('0' + sub_offset_i)) + ':00'
              };
            });
          }

          return {
            value: offset_i,
            display: (offset_i > 9 ? offset_i : ('0' + offset_i)) + ':00'
          };
        });
      }

      return Array(24).fill(null).map(function (el, i) {
        return {
          value: i,
          display: (i > 9 ? i : ('0' + i)) + ':00'
        };
      });
    },
    getEndSlotsFromSingle: function (slot) {
      if (!slot || slot.start === null || typeof slot.start == 'undefined') {
        return [];
      }

      var day_slots  = this.model.schedule_single;
      var slot_index = day_slots.indexOf(slot);

      var previous_slot = slot_index > 0 ? day_slots[slot_index - 1] : null;

      if (previous_slot) {
        return Array(24 - slot.start).fill(null).map(function (el, i) {
          var offset_i = i + slot.start + 1;

          if (offset_i > 23) {
            offset_i -= 24;

            return Array(slot.start - (slot.start - previous_slot.start) + 1).fill(null).map(function (el, sub_i) {
              var sub_offset_i = offset_i + sub_i;

              return {
                value: sub_offset_i,
                display: (sub_offset_i > 9 ? sub_offset_i : ('0' + sub_offset_i)) + ':00'
              };
            });
          }

          return {
            value: offset_i,
            display: (offset_i > 9 ? offset_i : ('0' + offset_i)) + ':00'
          };
        });
      }

      return Array(24 - slot.start).fill(null).map(function (el, i) {
        var offset_i = i + slot.start + 1;

        if (offset_i > 23) {
          offset_i -= 24;

          return Array(slot.start + 1).fill(null).map(function (el, sub_i) {
            var sub_offset_i = offset_i + sub_i;

            return {
              value: sub_offset_i,
              display: (sub_offset_i > 9 ? sub_offset_i : ('0' + sub_offset_i)) + ':00'
            };
          });
        }

        return {
          value: offset_i,
          display: (offset_i > 9 ? offset_i : ('0' + offset_i)) + ':00'
        };
      });
    },
    getStartSlotsFromMultiple: function (day, slot) {
      var day_index  = this.model.days.indexOf(day);
      var previous_day = day_index > 0 ? this.model.days[day_index - 1] : null;

      var day_slots  = this.model.schedule_multiple[day_index];
      var slot_index = day_slots.indexOf(slot);
      var previous_slot = slot_index > 0 ? day_slots[slot_index - 1] : null;

      var last_slot_last_hour = 0;
      if (previous_day && !previous_slot) {
        var last_day_slots = this.model.schedule_multiple[day_index - 1];
        var last_slot = last_day_slots[last_day_slots.length - 1];

        if (last_slot && last_slot.end && last_slot.end.is_next_day) {
          last_slot_last_hour = last_slot.end.hour;
        }
      }

      var hours_in_a_day = 24 - last_slot_last_hour;

      if (previous_slot && previous_slot.end) {
        return Array(hours_in_a_day - previous_slot.end.hour - 1).fill(null).map(function (el, i) {
          var offset_i = i + previous_slot.end.hour + 1;

          if (offset_i > (hours_in_a_day - 1)) {
            offset_i -= hours_in_a_day;

            return Array(previous_slot.end.hour + 1).fill(null).map(function (el, sub_i) {
              var sub_offset_i = offset_i + sub_i;

              return {
                value: sub_offset_i,
                display: (sub_offset_i > 9 ? sub_offset_i : ('0' + sub_offset_i)) + ':00'
              };
            });
          }

          return {
            value: offset_i,
            display: (offset_i > 9 ? offset_i : ('0' + offset_i)) + ':00'
          };
        });
      }

      return Array(hours_in_a_day).fill(null).map(function (el, i) {
        var offset_i = i + last_slot_last_hour;

        return {
          value: offset_i,
          display: (offset_i > 9 ? offset_i : ('0' + offset_i)) + ':00'
        };
      });
    },
    getEndSlotsFromMultiple: function (day, slot) {
      if (!slot || slot.start === null || typeof slot.start == 'undefined') {
        return [];
      }

      var day_index  = this.model.days.indexOf(day);
      var day_slots  = this.model.schedule_multiple[day_index];
      var slot_index = day_slots.indexOf(slot);

      var previous_slot = slot_index > 0 ? day_slots[slot_index - 1] : null;

      if (previous_slot) {
        return Array(24 - slot.start).fill(null).map(function (el, i) {
          var offset_i = i + slot.start + 1;

          if (offset_i > 23) {
            offset_i -= 24;

            return Array(slot.start - (slot.start - previous_slot.start) + 1).fill(null).map(function (el, sub_i) {
              var sub_offset_i = offset_i + sub_i;

              return {
                value: sub_offset_i,
                display: (sub_offset_i > 9 ? sub_offset_i : ('0' + sub_offset_i)) + ':00'
              };
            });
          }

          return {
            value: offset_i,
            display: (offset_i > 9 ? offset_i : ('0' + offset_i)) + ':00'
          };
        });
      }

      return Array(24 - slot.start).fill(null).map(function (el, i) {
        var offset_i = i + slot.start + 1;

        if (offset_i > 23) {
          offset_i -= 24;

          return Array(slot.start + 1).fill(null).map(function (el, sub_i) {
            var sub_offset_i = offset_i + sub_i;

            return {
              value: sub_offset_i,
              display: (sub_offset_i > 9 ? sub_offset_i : ('0' + sub_offset_i)) + ':00'
            };
          });
        }

        return {
          value: offset_i,
          display: (offset_i > 9 ? offset_i : ('0' + offset_i)) + ':00'
        };
      });
    },
    addSlotOnlyDay: function () {
      this.model.schedule_single.push({
        start: null,
        end: null
      });
    },
    removeSlotOnlyDay: function (slot) {
      this.model.schedule_single.splice(this.model.schedule_single.indexOf(slot), 1);
    },
    addSlotMultipleDay: function (day) {
      var day_index = this.model.days.indexOf(day);

      this.model.schedule_multiple[day_index].push({
        start: null,
        end: null
      });
    },
    removeSlotMultipleDay: function (day, slot) {
      var day_index = this.model.days.indexOf(day);

      this.model.schedule_multiple[day_index].splice(this.model.schedule_multiple[day_index].indexOf(slot), 1);
    }
  }
}
</script>
